// import React, { useEffect, useState } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import HTMLFlipBook from "react-pageflip";

// // ✅ Load the PDF worker bundled with react-pdf
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

// export default function App() {
//   const [pdfUrl, setPdfUrl] = useState(null);
//   const [numPages, setNumPages] = useState(null);

//   useEffect(() => {
//     // Fetch PDF from backend (avoids CORS issues)
//     fetch("https://lcoiapi.emedha.in/appi/get-pdf")
//       .then((res) => res.blob())
//       .then((blob) => {
//         const url = URL.createObjectURL(blob);
//         setPdfUrl(url);
//       })
//       .catch((err) => console.error("Error fetching PDF:", err));
//   }, []);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//   }

//   return (
//     <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
//       {pdfUrl && (
//         <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
//           <HTMLFlipBook width={500} height={700}>
//             {Array.from(new Array(numPages), (el, index) => (
//               <div key={`page_${index + 1}`} className="page">
//                 <Page pageNumber={index + 1} width={500} />
//               </div>
//             ))}
//           </HTMLFlipBook>
//         </Document>
//       )}
//     </div>
//   );
// }


// import React, { useEffect, useState } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import HTMLFlipBook from "react-pageflip";
// import "./App.css"; // ✅ Add custom styles

// // ✅ Load the PDF worker bundled with react-pdf
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

// export default function App() {
//   const [pdfUrl, setPdfUrl] = useState(null);
//   const [numPages, setNumPages] = useState(null);

//   useEffect(() => {
//     // Fetch PDF from backend (avoids CORS issues)
//     fetch("https://lcoiapi.emedha.in/appi/get-pdf")
//       .then((res) => res.blob())
//       .then((blob) => {
//         const url = URL.createObjectURL(blob);
//         setPdfUrl(url);
//       })
//       .catch((err) => console.error("Error fetching PDF:", err));
//   }, []);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//   }

//   return (
//     <div className="app-container">
//       <h2 className="title">📖 PDF Flipbook Viewer</h2>

//       {pdfUrl && (
//         <div className="flipbook-wrapper">
//           <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
//             <HTMLFlipBook
//               width={500}
//               height={700}
//               showCover={true}
//               className="flipbook"
//             >
//               {Array.from(new Array(numPages), (el, index) => (
//                 <div key={`page_${index + 1}`} className="page">
//                   <Page pageNumber={index + 1} width={500} />
//                 </div>
//               ))}
//             </HTMLFlipBook>
//           </Document>
//         </div>
//       )}
//     </div>
//   );
// }



// import React, { useEffect, useState } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import HTMLFlipBook from "react-pageflip";
// import "./style.css";

// // ✅ Load the PDF worker bundled with react-pdf
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   "pdfjs-dist/build/pdf.worker.min.mjs",
//   import.meta.url
// ).toString();

// export default function FlipBook() {
//   const [pdfUrl, setPdfUrl] = useState(null);
//   const [numPages, setNumPages] = useState(null);

//   useEffect(() => {
//     // Fetch PDF from backend (avoids CORS issues)
//     fetch("https://lcoiapi.emedha.in/appi/get-pdf")
//       .then((res) => res.blob())
//       .then((blob) => {
//         const url = URL.createObjectURL(blob);
//         setPdfUrl(url);
//       })
//       .catch((err) => console.error("Error fetching PDF:", err));
//   }, []);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//   }

//   return (
//     <div className="app-container">
//       <h2 className="title">📖 PDF Flipbook Viewer</h2>

//       {pdfUrl && (
//         <div className="flipbook-wrapper">
//           <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
//             <HTMLFlipBook
//               width={500}     // single page width
//               height={700}    // page height
//               size="stretch"  // stretch pages responsively
//               minWidth={400}  
//               maxWidth={1000}
//               minHeight={500}
//               maxHeight={1500}
//               drawShadow={true}
//               flippingTime={700}
//               usePortrait={false}   // ✅ allow two-page spread
//               startPage={0}
//               autoSize={true}
//               clickEventForward={true}
//               showCover={true}
//               className="flipbook"
//             >
//               {Array.from(new Array(numPages), (_, index) => (
//                 <div key={`page_${index + 1}`} className="page">
//                   <Page
//                     pageNumber={index + 1}
//                     width={500}
//                     renderAnnotationLayer={false}
//                     renderTextLayer={false}
//                   />
//                 </div>
//               ))}
//             </HTMLFlipBook>
//           </Document>
//         </div>
//       )}
//     </div>
//   );
// }


// // import React, { useEffect, useState } from "react";
// // import { Document, Page, pdfjs } from "react-pdf";
// // import HTMLFlipBook from "react-pageflip";

// // // ✅ Load the PDF worker bundled with react-pdf
// // pdfjs.GlobalWorkerOptions.workerSrc = new URL(
// //   "pdfjs-dist/build/pdf.worker.min.mjs",
// //   import.meta.url
// // ).toString();

// // export default function App() {
// //   const [pdfUrl, setPdfUrl] = useState(null);
// //   const [numPages, setNumPages] = useState(null);
// //   const [bookSize, setBookSize] = useState({ width: 500, height: 700 });

// //   useEffect(() => {
// //     // Fetch PDF from backend (avoids CORS issues)
// //     fetch("https://lcoiapi.emedha.in/appi/get-pdf")
// //       .then((res) => res.blob())
// //       .then((blob) => {
// //         const url = URL.createObjectURL(blob);
// //         setPdfUrl(url);
// //       })
// //       .catch((err) => console.error("Error fetching PDF:", err));
// //   }, []);

// //   useEffect(() => {
// //     const updateSize = () => {
// //       const screenWidth = window.innerWidth;

// //       if (screenWidth < 480) {
// //         // 📱 Mobile
// //         setBookSize({ width: screenWidth - 40, height: (screenWidth - 40) * 1.4 });
// //       } else if (screenWidth < 1024) {
// //         // 💻 Tablet
// //         setBookSize({ width: 600, height: 850 });
// //       } else {
// //         // 🖥 Desktop
// //         setBookSize({ width: 800, height: 1100 });
// //       }
// //     };

// //     updateSize();
// //     window.addEventListener("resize", updateSize);
// //     return () => window.removeEventListener("resize", updateSize);
// //   }, []);

// //   function onDocumentLoadSuccess({ numPages }) {
// //     setNumPages(numPages);
// //   }

// //   return (
// //     <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
// //       {pdfUrl && (
// //         <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
// //           <HTMLFlipBook
// //             width={bookSize.width}
// //             height={bookSize.height}
// //             size="stretch" // ✅ helps auto-scale
// //             minWidth={300}
// //             maxWidth={1000}
// //             minHeight={400}
// //             maxHeight={1400}
// //             style={{ margin: "auto" }}
// //           >
// //             {Array.from(new Array(numPages), (el, index) => (
// //               <div key={`page_${index + 1}`} className="page">
// //                 <Page pageNumber={index + 1} width={bookSize.width} />
// //               </div>
// //             ))}
// //           </HTMLFlipBook>
// //         </Document>
// //       )}
// //     </div>
// //   );
// // }




import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useLocation } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";
import "./style.css";

// ✅ Load the PDF worker bundled with react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export default function FlipBook( ) {
  const [numPages, setNumPages] = useState(null);
   const location = useLocation(); // Get location object
  const [pdfUrl, setPdfUrl] = useState(location?.state?.pdfUrl || null); 
  const [error, setError] = useState('');

 useEffect(() => {
    if (location?.state?.pdfUrl) {
      // Whenever the location state changes (i.e., a new month is selected), update the PDF URL
      setPdfUrl(location.state.pdfUrl);
      setError('');
    }
  }, [location]);  // This will run every time location changes


  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  if (!pdfUrl) {
    return <div style={{ color: 'red', textAlign: 'center' }}>No PDF available</div>;
  }

  return (
    <div className="app-container">
      <h2 className="title">📖 PDF Flipbook Viewer</h2>

      {pdfUrl && (
        <div className="flipbook-wrapper">
          <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
            <HTMLFlipBook
              width={500}     // single page width
              height={700}    // page height
              size="stretch"  // stretch pages responsively
              minWidth={400}  
              maxWidth={1000}
              minHeight={500}
              maxHeight={1500}
              drawShadow={true}
              flippingTime={700}
              usePortrait={false}   // ✅ allow two-page spread
              startPage={0}
              autoSize={true}
              clickEventForward={true}
              showCover={true}
              className="flipbook"
            >
              {Array.from(new Array(numPages), (_, index) => (
                <div key={`page_${index + 1}`} className="page">
                  <Page
                    pageNumber={index + 1}
                    width={500}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                </div>
              ))}
            </HTMLFlipBook>
          </Document>
        </div>
      )}
    </div>
  );
}
